import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddModulTipProgramActivPayload, IEditModulTipProgramActivPayload, IModulTipProgramActivFind } from './module-tipuri-program-active.interface';
import { catchError, map, throwError } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class ModuleTipuriProgramActiveService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listModuleTipProgramActivURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.list;
    private listDTModuleTipProgramActivURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.listDT;
    private addModulTipProgramActivURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.store;
    private updateModulTipProgramActivURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.update;
    private deleteModulTipProgramActivURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.delete;
    private findByModuleURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.findByModule;

    constructor(private http: HttpClient) { }

    listModuleTipProgramActiv() {
        return this.http.get(this.listModuleTipProgramActivURL);
    }

    listDTModuleTipProgramActiv() {
        return this.http.post(this.listDTModuleTipProgramActivURL, {});
    }

    addModulTipProgramActiv(data: IAddModulTipProgramActivPayload) {
        return this.http.post(this.addModulTipProgramActivURL, data);
    }

    updateModulTipProgramActiv(data: IEditModulTipProgramActivPayload) {
        return this.http.put(this.updateModulTipProgramActivURL, data);
    }

    deleteModulTipProgramActiv(id: number) {
        return this.http.delete(this.deleteModulTipProgramActivURL + id);
    }

    findByModule(id: number) {
        return this.http.get<{ errors: boolean; data: IModulTipProgramActivFind[]; status_code: number }>(
            this.findByModuleURL + id,
        ).pipe(
            map((response) =>
                response.data.map((item) => ({
                    id: item.program_type.id_program_type,
                    name: item.program_type.name,
                }))
            ),
            catchError((error) => {
                console.error('Error in get tipuri program modul:', error);
                return throwError(error);
            })
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
